import {
  Item,
  registry,
  RenderProps
} from '~/training/sequence/templates/items/Item';
import { BUTTON_FOR_MULTIMEDIA2 } from '~/training/sequence/templates/items';
import React from 'react';
import styled, { x } from '@xstyled/styled-components';
import { MediaPlayerStore } from '~/ui/video-player/MediaPlayerStore';
import { select } from '~/lib/select';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';
import { shallow } from 'zustand/shallow';
import { PlayButton } from '~/ui/buttons';
import { drillAnimation } from '~/ui/animation';

const WrapperForButton = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .playBtnSvg {
    scale: 2.5;
    margin-left: 10px;

    visibility: visible;
    opacity: 1;
    transform: none;
  }
`;

const DrillBoxAnimation = styled.div`
  width: 120px;
  height: 120px;
  animation: ${drillAnimation} 2.3s ease infinite;
  position: absolute;
  background-color: accentDark;
  border-radius: 50%;
  opacity: 0.5;
`;

const selector = (s: MediaPlayerStore) =>
  select(s, 'status', 'toggle', 'progress', 'play');

interface Props {
  url?: string;
}

export class ButtonForMultimedia2 extends Item<
  typeof BUTTON_FOR_MULTIMEDIA2,
  Props
> {
  protected render({ url }: RenderProps<Props>) {
    const { status, progress, play } = useMediaPlayerStore(selector, shallow);

    const PlayEvent = () => {
      if (status === 'ready') {
        play();
      }
    };

    if (status === 'ready') {
      return (
        <WrapperForButton>
          <x.div
            w="100px"
            h="100px"
            borderRadius="50%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            position="relative"
          >
            <DrillBoxAnimation />
            <PlayButton
              onClick={PlayEvent}
              state={'ready'}
              progress={progress}
              style={{ width: '100px', height: '100px', borderRadius: '50%' }}
            />
          </x.div>
        </WrapperForButton>
      );
    }

    return null;
  }
}

registry[BUTTON_FOR_MULTIMEDIA2] = ButtonForMultimedia2;
